import { fetchBaseQuery, createApi } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../constants";

import axios from "axios";

import { Flip, toast } from "react-toastify";

import { logout } from "./userSlice";

export const logoutTwitchUser = async () => {
  let response = await axios.post("/api/twitch/logout");
  return response;
};

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
});

async function baseQueryWithAuth(args, api, extra) {
  const result = await baseQuery(args, api, extra);
  if (result.error && result.error.status === 401) {
    await logoutTwitchUser();
    api.dispatch(logout());
    toast.error(`${result.error.data.message}`, {
      position: "bottom-left",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Flip,
    });
  }
  return result;
}

export const apiSlice = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Post", "User", "Profile", "Tag"],
  endpoints: (builder) => ({}),
});
